// redux/slices/publicRecurringBreakSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { getServerUrl } from "../../Utils/serverSelector"

export const fetchPublicRecurringBreaks = createAsyncThunk(
    "publicRecurringBreak/fetch",
    async (uid, { rejectWithValue }) => {
        try {
            if (!uid) throw new Error("UID не передан")
            const res = await axios.get(`${getServerUrl()}/public/${uid}/recurring-breaks`)
            return { uid: String(uid), items: Array.isArray(res.data) ? res.data : [] }
        } catch (e) {
            return rejectWithValue(e?.response?.data || e.message || "Fetch recurring breaks failed")
        }
    }
)

const publicRecurringBreakSlice = createSlice({
    name: "publicRecurringBreak",
    initialState: {
        byUid: {},      // { [uid]: RecurringBreak[] }
        status: "idle",
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPublicRecurringBreaks.pending, (state) => {
                state.status = "loading"
            })
            .addCase(fetchPublicRecurringBreaks.fulfilled, (state, action) => {
                state.status = "succeeded"
                const { uid, items } = action.payload
                state.byUid[uid] = items
            })
            .addCase(fetchPublicRecurringBreaks.rejected, (state, action) => {
                state.status = "failed"
                state.error = action.payload
            })
    },
})

export const selectPublicRecurringBreaksByUid = (state, uid) =>
    state.publicRecurringBreak?.byUid?.[String(uid)] || []

export default publicRecurringBreakSlice.reducer